import { noteDefaultFieldStyles } from '@/components/settings/NoteDefaultField.styles';
import type { NoteDefaultFieldProps } from '@/components/settings/NoteDefaultsSettings.types';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Stack, Text } from '@careflux/primitives';

export const NoteDefaultField = <T extends string>({
  id,
  label,
  options,
  value,
  disabled,
  onChange,
}: NoteDefaultFieldProps<T>) => (
  <Stack gap="sm">
    <Text id={id} size="sm" weight="medium">
      {label}
    </Text>
    <RadioGroup
      aria-labelledby={id}
      value={value}
      disabled={disabled}
      onValueChange={(next) => {
        const option = options.find((candidate) => candidate.value === next);
        if (option) onChange(option.value);
      }}
      className={noteDefaultFieldStyles.group}
    >
      {options.map((option) => (
        <label key={option.value} htmlFor={`${id}-${option.value}`} className={noteDefaultFieldStyles.option}>
          <RadioGroupItem value={option.value} id={`${id}-${option.value}`} />
          {option.label}
        </label>
      ))}
    </RadioGroup>
  </Stack>
);
